var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.194 4.975C13.054 2.073 10.269.117 7.11 0 3.953.117 1.168 2.073.028 4.975c-.037.102-.037.214 0 .317 1.14 2.902 3.925 4.858 7.083 4.975 3.158-.117 5.943-2.073 7.083-4.975.037-.103.037-.215 0-.317zM7.11 9.333c-2.513 0-5.167-1.834-6.13-4.2.963-2.366 3.617-4.2 6.13-4.2s5.167 1.834 6.13 4.2c-.963 2.366-3.617 4.2-6.13 4.2z",
    transform: "translate(.884 .667) translate(1.016 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11 2.333c-1.57 0-2.844 1.254-2.844 2.8 0 1.547 1.274 2.8 2.845 2.8 1.57 0 2.844-1.253 2.844-2.8 0-1.546-1.273-2.8-2.844-2.8zM7.11 7c-1.046 0-1.895-.836-1.895-1.867 0-1.03.849-1.866 1.896-1.866s1.896.835 1.896 1.866c0 .495-.2.97-.555 1.32-.356.35-.838.547-1.341.547z",
    transform: "translate(.884 .667) translate(1.016 3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16.254V16H0z",
    transform: "translate(.884 .667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f97ed6b6897f8f2930150bb08f4ddf2d.svg";
export { ForwardRef as ReactComponent };